export default __webpack_public_path__ + "static/media/bell-icon.119f4ece.svg";